import { useRecoilTransaction_UNSTABLE } from "recoil"

import { designLocalState } from "~/containers/Proposal/state/designs/design-state"

import type { TransactionOperation } from "."
import { edgeSelectionState } from "../edges"
import { nodeSelectionState_INTERNAL } from "../nodeSelection"
import { panelSelectionState } from "../panels"

export const resetSelection: TransactionOperation = ({ set, get }) => {
  const { phase } = get(designLocalState)
  switch (phase) {
    case `Outline`:
      set(nodeSelectionState_INTERNAL, new Set())
      set(edgeSelectionState, new Set())
      break
    case `Panel Activation`:
    case `Panel Placement`:
      set(panelSelectionState, new Set())
      break
  }
}
export const useResetSelection = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => resetSelection(transactors),
  )
